import translate from '../core/tools/translate';
import CoreControl from './CoreControl';
import { VectorType } from './VectorType';

export class FarmMachineControl extends CoreControl {
  constructor() {
    super({name: 'FarmMachine'});

    this.select = this.select.bind(this);

    this._instance = null;
  }

  static getInstance() {
    if (!FarmMachineControl._instance) {
      FarmMachineControl._instance = new FarmMachineControl();
    }

    return FarmMachineControl._instance;
  }

  init() {
    const values = {
      help: translate(`Help.${this.options.name}`),
      id: 'layer-farm-machine',
      input: 'checkbox',
      label: translate(`Common.${this.options.name}`),
      layer: this.getLayer,
      change: this._change,
      name: this.options.name,
      type: 'vector-points',
      filter: {
        enable: false,
      }
    };

    if (!this._instance) {
      this._instance = new VectorType(values);
    }
  }

  select(value) {
    this.getLayer().setOptions({
      remote: {
        params: {
          id: value
        }
      }
    });

    if (this.check() && this.getLayer().visible()) {
      return this.getLayer().redraw();
    }
  }
}

export default FarmMachineControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/FarmMachineControl.js